/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Marketing_DateInputs */

const en_wb_marketing_date = /** @type {(inputs: Wb_Marketing_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AUGUST · SAMPLE CAMPAIGN REVIEW`)
};

const lv_wb_marketing_date = /** @type {(inputs: Wb_Marketing_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AUGUSTS · KAMPAŅAS PĀRSKATA PARAUGS`)
};

/**
* | output |
* | --- |
* | "AUGUST · SAMPLE CAMPAIGN REVIEW" |
*
* @param {Wb_Marketing_DateInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_marketing_date = /** @type {((inputs?: Wb_Marketing_DateInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Marketing_DateInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_marketing_date(inputs)
	return en_wb_marketing_date(inputs)
});